<template>
  <van-popup v-model="isShowPicker" round position="bottom">
    <van-picker ref="pickerRef" show-toolbar :columns="areaList" value-key="name" @cancel="closeAreaPicker" @confirm="onConfirm"></van-picker>
  </van-popup>
</template>

<script>
// 地址选择组件.  地址选择组件 popup是挂载在body上，所以该组件不放在页面dom处，而是页面dom底部

const areaList = require('_util/area-list.json');
export default {
  name: 'FtAddress',
  props: {
    province: {
      default() {
        return '';
      }
    },
    city: {
      default() {
        return '';
      }
    },
    area: {
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      areaList,
      // 是否显示picker
      isShowPicker: false
    };
  },
  mounted() {},
  methods: {
    openAreaPicker() {
      this.isShowPicker = true;
      // popup组件是动态生成的，因为只有isShowPicker为true后，才可以获取this.$ref
      this.$nextTick(() => {
        const picker = this.$refs.pickerRef;
        if (this.province) {
          picker.setColumnValue(0, this.province);
        }
        if (this.city) {
          picker.setColumnValue(1, this.city);
        }
        if (this.area) {
          picker.setColumnValue(2, this.area);
        }
      });
    },
    closeAreaPicker() {
      this.isShowPicker = false;
    },
    onConfirm(value) {
      // 使用v-model方式直接获取选中的省市区数组
      this.$emit('input', value);
      // 通过:prop.sync的方式获取具体的选中值
      if (value && value.length) {
        this.$emit('update:province', value[0]);
        this.$emit('update:city', value[1]);
        this.$emit('update:area', value[2]);
      }
      this.closeAreaPicker();
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ftAddress.vue